import React, { useEffect, useState } from "react";

import ResumeStrengthMobileView from "./ResumeStrengthMobileView";
import ResumeStrengthDesktopView from "./ResumeStrengthDesktopView";
import { APP_DOMAIN, REVIEW_ERROR_TYPES } from "../../constants/constants";

const ResumeReviewComponent = ({review, children}) => {
  const [mobileDevice, setMobileDevice] = useState('');
    const scorePoint = review?.resume_score?.total_points;
    const strength = review?.resume_score?.resume_strength;
    useEffect(()=>{
      //First time
        setMobileDevice(window.innerWidth > 769 ? false : true );
        //every second time
        function handleResize() {
            setMobileDevice(window.innerWidth > 769 ? false : true );
        }
        window.addEventListener('resize', handleResize);
    // Remove the event listener when the component unmounts
    return () => {
      window.removeEventListener('resize', handleResize);
    };
    },[])

    return <div className='info-section'>
    <div className='title-info'>
      <h2>{scorePoint === 100 
            ? "Your resume looks great" 
            : "Let’s shape up your resume."
          }</h2>
      <span>{scorePoint === 100 
            ? "Congratulations, you've crafted a flawless resume that's ready to give you an edge on your job search!"
            : "You’re just a few minutes away from a perfect resume! We’ll help you improve these:"
          }</span>
    </div>
    <div className='key-measure-box'>
      <div className="result-box">
        {!mobileDevice && <ResumeStrengthDesktopView strength ={strength} scorePoint={scorePoint}/>}

        {mobileDevice &&
        <><div className="resume-score">
            <span>Power Score</span>
            <span>{!isNaN(scorePoint) ? `${scorePoint}%` : <img src={`${APP_DOMAIN}/assets/images/question.svg`} />}</span>
        </div>
        
        <ResumeStrengthMobileView progress={!isNaN(scorePoint) ? scorePoint : 0} /></>
        }

      </div>
      {mobileDevice && <div className="review-btn-container ">
        <div className='reveiw-btn'>
         {children}
          {/* <span>{scorePoint ? 'Fix Now' : 'Review Now'}</span> */}
        </div>
      </div>}
      <div className='key-points'>
        <div className='left-items'>
          {REVIEW_ERROR_TYPES.slice(0,4).map((v,k) =>(
          <div key = {k} className={`item ${(review?.error_types && review.error_types.hasOwnProperty(v.key)) ? '' : 'disabled'}`} >
            <div className="e-status">
              <div className={`e-circle ${review?.error_types?.[v.key] ? 'bg-error' : 'bg-success'}`}></div>
            </div>
            <span>{v.label}</span>
          </div>
           ))}
           </div>
           <div className='right-items'>
          {REVIEW_ERROR_TYPES.slice(-4).map((v,k) =>(
          <div key = {k} className={`item ${(review?.error_types && review.error_types.hasOwnProperty(v.key)) ? '' : 'disabled'}`} >
            <div className="e-status">
              <div className={`e-circle ${review?.error_types?.[v.key] ? 'bg-error' : 'bg-success'}`}></div>
            </div>
            <span>{v.label}</span>
          </div>
           ))}
           </div>
      </div>
    </div>
  </div>
}
export default ResumeReviewComponent;